export default function authHeader() {
    let user = (sessionStorage.getItem('jwt'));
    if (user) {
      return { Authorization: 'Bearer ' + user };
    } else {
      return {};
    }
  }
  